import React from "react";
import TooltipText from "../tooltipText";

const ChartCard = ({ title, footer, chips = [], children, className = "" }) => {
  return (
    <div className={`card chart-card ${className}`.trim()}>
      <div className="course-card-title">
        <strong className="chart-card-title-text">
          <TooltipText text={title} fullWidth />
        </strong>
        {Array.isArray(chips) && chips.length > 0 ? (
          <div className="chart-title-chips">
            {chips.map((c, idx) => (
              <span key={`${String(c)}-${idx}`} className="chart-title-chip">
                {c}
              </span>
            ))}
          </div>
        ) : null}
      </div>
      {footer ? <div className="chart-card-footer">{footer}</div> : null}
      <div className="chart-container chart-scrollbar">{children}</div>
    </div>
  );
};

export default ChartCard;
